import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Heading } from '@instructure/ui-heading';
import { Text } from '@instructure/ui-text';
import { View } from '@instructure/ui-view';
import { RichContentRenderer } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/es/format-message';
var StimulusShowInfo = /*#__PURE__*/function (_Component) {
  function StimulusShowInfo() {
    _classCallCheck(this, StimulusShowInfo);
    return _callSuper(this, StimulusShowInfo, arguments);
  }
  _inherits(StimulusShowInfo, _Component);
  return _createClass(StimulusShowInfo, [{
    key: "render",
    value: function render() {
      var stimulus = this.props.stimulus;
      var automationPrefix = stimulus.passage ? 'passage' : 'stimulus';
      var instructions = stimulus.instructions && /*#__PURE__*/React.createElement(View, {
        as: "div",
        padding: "small",
        margin: "x-small 0 0 0",
        background: "secondary"
      }, /*#__PURE__*/React.createElement(View, {
        as: "div"
      }, /*#__PURE__*/React.createElement(Text, {
        color: "primary",
        size: "small"
      }, t('Instructions'))), /*#__PURE__*/React.createElement(View, {
        as: "div",
        padding: "0 0 small 0"
      }, /*#__PURE__*/React.createElement("div", {
        "data-automation": "sdk-stimulus-LeftPanelShow-instructions"
      }, /*#__PURE__*/React.createElement(Text, {
        color: "primary",
        size: "small",
        weight: "bold"
      }, stimulus.instructions))));
      return /*#__PURE__*/React.createElement(View, {
        as: "div"
      }, stimulus.title && /*#__PURE__*/React.createElement(Heading, {
        level: "h3",
        as: "h2",
        color: "primary",
        margin: "0 0 small",
        themeOverride: {
          h2FontWeight: '700'
        }
      }, stimulus.title), instructions, /*#__PURE__*/React.createElement("div", {
        "data-automation": "sdk-".concat(automationPrefix, "-LeftPanelShow-content")
      }, /*#__PURE__*/React.createElement(RichContentRenderer, {
        content: this.props.stimulus.body
      })));
    }
  }]);
}(Component);
_defineProperty(StimulusShowInfo, "propTypes", {
  stimulus: ImmutablePropTypes.record.isRequired
});
export default StimulusShowInfo;